<template>
  <v-container
    style="background-color: #fff;height: (100vh - 42px)"
    fluid
    class="pt-0"
  >
    <v-row>
      <v-col class="pa-0">
        <v-img :src="require('@/assets/mobile/bg_mobile.png')" alt></v-img>
      </v-col>
    </v-row>
    <v-row>
      <v-card
        width="100%"
        class="px-4"
        elevation="0"
        light
        style="background-color: #fff;"
      >
        <v-row>
          <v-col class="pb-0">
            <v-text-field
              background-color="#E6ECF3"
              label="아이디"
              solo
              height="48"
              hide-details
              dense
              placeholder="아이디를 입력하세요"
              v-model="userId"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-0">
            <v-text-field
              background-color="#E6ECF3"
              solo
              height="48"
              hide-details
              dense
              type="password"
              placeholder="비밀번호를 입력하세요"
              @keyup.enter="signIn"
              v-model="userPassword"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-0 d-flex justify-end align-center">
            <v-checkbox
              class="mg0 pr-2"
              color="gray"
              v-model="is_saved"
              hide-details
            >
              <template v-slot:label>
                <span class="font-size-12">아이디저장</span>
              </template>
            </v-checkbox>
            <v-checkbox
              class="mg0"
              color="gray"
              v-model="isAutoLogin"
              hide-details
            >
              <template v-slot:label>
                <span class="font-size-12">자동로그인</span>
              </template>
            </v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <v-btn class="text-body-2 blue-type-btn-bg" block @click="signIn"
              >로그인</v-btn
            >
          </v-col>
        </v-row>
        <v-row>
          <v-col class="d-flex justify-center align-center py-0">
            <v-btn
              text
              x-small
              class="font-size-btn font-size-12 pdLR0"
              @click="moveFindIdPw('id')"
              style="font-weight: 500;"
              >아이디찾기</v-btn
            >
            <v-btn
              text
              x-small
              class="font-size-btn font-size-12 pdLR0"
              @click="moveFindIdPw('pw')"
              style="font-weight: 500;"
              >비밀번호찾기</v-btn
            >
            <v-btn
              text
              x-small
              class="font-size-btn font-size-12 pdLR0"
              style="font-weight: 500;"
              to="/regist"
              >회원가입</v-btn
            >
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-row>
            <v-col class="requestAsColor flex align-center pb-0 pt-16">
              제품문의 및 AS
              <a
                class="numberColor callNum"
                style="text-decoration: none"
                href="tel:1522-5001"
                >1522-5001</a
              >
            </v-col>
          </v-row>
        </v-row>
      </v-card>
    </v-row>
    <!-- <v-row class="justify-end">
      <v-col cols="7" class="d-flex justify-end">
        <v-img width="150" :src="require('@/assets/image/pc/fot_logo_02.jpg')" alt="logo"></v-img>
      </v-col>
    </v-row>-->
    <v-row v-show="false">
      <v-col>
        <v-card elevation="0" light style="background-color: #fff;">
          <v-card-title class="btmLine">
            <span class="notice-title-style notice-color">NOTICE</span>
            <span class="notice-color">공지사항</span>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-simple-table class="cursor" dense light>
              <tbody>
                <tr
                  v-for="(item, index) in noticeList"
                  :key="index"
                  @click="toggleContext(index, 'notice')"
                >
                  <td class="date" style="border-bottom-width: 0">
                    {{ item.insdate }}
                  </td>
                  <td class="board_title" style="border-bottom-width: 0">
                    <div class="context-list-title">{{ item.title }}</div>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-show="false">
      <v-col>
        <v-card elevation="0" light style="background-color: #fff;">
          <v-card-title class="btmLine">
            <span class="notice-title-style resource-color">RESOURCE</span>
            <span class="resource-color">자료실</span>
          </v-card-title>
          <v-card-text class="pa-0">
            <v-simple-table class="cursor" dense light>
              <tbody>
                <tr
                  v-for="item in resourceList"
                  :key="item.no"
                  @click="toggleContext(item.no, 'resource')"
                >
                  <td class="date" style="border-bottom-width: 0">
                    {{ item.date }}
                  </td>
                  <td class="board_title" style="border-bottom-width: 0">
                    {{ item.title }}
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <open-alert-dialog :show-event="showAlert"></open-alert-dialog>
    <notice-dialog
      white
      :type="context.type"
      :context="context"
      :show-event="showContext"
    ></notice-dialog>
    <general-dialog v-model="modal" :title="popupTitle" :buttons="buttons">
      <v-card flat>
        <v-card-text>
          <v-form ref="CertificateForm">
            <v-row>
              <v-col
                cols="12"
                class="pt-0"
                v-show="!showCheckEmail"
                v-if="loginCount > 4"
              >
                <span class="text-caption"
                  >비밀번호를 5회 이상 틀리셨습니다. 2차 인증이 필요합니다</span
                >
              </v-col>
              <v-col cols="12" class="pt-0" v-show="showCheckEmail">
                <span class="text-caption"
                  >등록하신 이메일로 인증번호가 발송되었습니다. 발송된
                  인증번호를 입력해주세요.</span
                >
              </v-col>
              <v-col cols="7" md="8" v-if="true">
                <v-text-field
                  outlined
                  dense
                  hide-details="auto"
                  v-model="certificateNumber"
                  label="인증번호"
                >
                </v-text-field>
              </v-col>
              <v-col
                class="pl-0 align-self-center"
                cols="5"
                md="4"
                v-if="!showCheckEmail"
              >
                <v-btn
                  outlined
                  class="default-btn"
                  :disabled="disableSendEmail"
                  v-show="!disableSendEmail"
                  block
                  @click="sendEmail"
                  >인증번호발송</v-btn
                >
              </v-col>
              <v-col class="pl-0 align-self-center" cols="5" md="4" v-else>
                <v-btn outlined class="default-btn" block @click="sendEmail"
                  >재전송</v-btn
                >
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </general-dialog>
  </v-container>
</template>

<script>
import localStore from '@/utils/localStore'
import { getMonitoringPersonal } from '@/api/monitoring/monitoring'
import {
  checkForEmail,
  certificateForEmail,
  resetLoginCount
} from '@/api/common/login'
import { isMobile } from '@/utils/check.js'
import store from '@/store'
import Cookies from 'js-cookie'
import OpenAlertDialog from '@/components/monitoring/OpenAlertDialog'
import GeneralDialog from '@/components/dialogSet/GeneralDialog'
import NoticeDialog from '@/components/monitoring/NoticeDialog'
import { getNoticeList } from '@/api/greenCommon/common'
import router from '@/router'
import Message from '@/utils/message'
import { getToken, setToken } from '@/utils/token'
import { getAgentType } from '@/utils/check'

export default {
  components: {
    OpenAlertDialog,
    NoticeDialog,
    GeneralDialog
  },
  data() {
    return {
      isAutoLogin: false,
      retrieveData: {
        title: '', // 제목
        contents: '', // 상세내용
        create_user_name: '', // 작성자
        itemsPerPage: 4,
        currentPage: 1 // 현재 페이지
      },
      popupTitle: '사용자 인증',
      modal: false,
      certificateNumber: '',
      showCheckEmail: false,
      disableSendEmail: false,
      email: '',
      loginCount: '',
      buttons: [
        {
          title: '인증번호확인',
          color: 'primary',
          class: 'white--text',
          handler: () => {
            this.closePopup()
          }
        }
      ],
      context: {
        type: 'notice',
        title: '',
        date: '',
        context: ''
      },
      showContext: false,
      showAlert: false,
      title: 'LOGIN',
      userId: '',
      userPassword: '',
      idEmpty: false,
      pwEmpty: false,
      idPwCheck: false,
      is_saved: false,
      noticeList: [],
      resourceList: [],
      close: false
    }
  },
  created() {
    this.autoLogin()

    getNoticeList(this.retrieveData).then(res => {
      this.noticeList = res
    })
    this.init_page()
  },
  mounted() {
    store.dispatch('SetFooterUse', true)
  },
  methods: {
    autoLogin() {
      if (Cookies.get('autoLogin') !== undefined) {
        let data = Cookies.get('autoLogin').split('[####]')
        store
          .dispatch('LoginByPassword', {
            userId: data[0],
            userPassword: atob(data[1])
          })
          .then(response => {
            this.$store.dispatch('SetUserInfo').then(response => {
              this.$store.dispatch('GetUserMenus', store.state.user.userId)
              router.replace('/monitoring').catch(res => {})
            })
          })
          .catch(reject => {
            if (navigator.onLine === false) {
              Message.err('네트워크에 연결되어 있지 않습니다.')
            } else {
              Message.err('아이디 또는 비밀번호가 다릅니다.')
            }
            // Message.err('아이디 또는 비밀번호가 다릅니다.')
            router.replace('/login')
          })
      }
    },
    moveFindIdPw(type) {
      this.$router.push({ name: 'FindIdPw', query: { type: type } })
    },
    toggleAlert() {
      this.showAlert = !this.showAlert
    },
    init_page() {
      if (Cookies.get('saveID') !== undefined) {
        this.userId = Cookies.get('saveID')
        this.is_saved = true
      } else {
        this.is_saved = false
      }

      if (Cookies.get('autoLogin') !== undefined) {
        this.isAutoLogin = true
      } else {
        this.isAutoLogin = false
      }
    },
    moveJoinPage() {
      this.$router.push('/phoneCertificate')
    },
    signIn() {
      if (this.userId === '') {
        this.idEmpty = true
        this.pwEmpty = false
        this.idPwCheck = false
        alert('아이디를 입력해주세요.')
        return
      }

      if (this.userPassword === '') {
        this.idEmpty = false
        this.pwEmpty = true
        this.idPwCheck = false
        alert('비밀번호를 입력해주세요.')
        return
      }
      // store에 정의한 Login을 사용한다.
      store
        .dispatch('LoginByPassword', {
          userId: this.userId,
          userPassword: this.userPassword
        })
        .then(response => {
          // Login이 완료될 경우
          this.pwEmpty = false
          this.idEmpty = false
          this.idPwCheck = false

          // user 정보를 가져온다.
          this.$store.dispatch('SetUserInfo').then(response => {
            // user 정보를 가져온 이후에 이동 및 메뉴 적용
            // this.$store.dispatch('GetMenus')
            // console.log(isMobile())
            // 중간에 인증창이 닫힐시 초기화
            this.modal = false
            this.showCheckEmail = false
            this.disableSendEmail = false

            let grpCd = localStore.get('grp_auth')
            this.loginCount = localStore.get('login_count')
            this.email = localStore.get('email')

            // 관리자 계정 및 Login Retry Count 5회 체크, 체크시 2차 인증으로 이동 2025-01-23 일시 비활성화
            // if (grpCd === 'usergroup001' || this.loginCount > 4) {
            //  this.modal = true
            // } else {
            //  this.process()
            // }

            this.process()
          })
        })
        .catch(reject => {
          // Login이 실패할 경우
          console.error('login fail:', reject)
          this.pwEmpty = false
          this.idEmpty = false
          this.idPwCheck = true

          if (navigator.onLine === true) {
            alert('아이디 또는 비밀번호가 다릅니다.')
          } else {
            alert('네트워크에 연결되어 있지 않습니다.')
          }
          // alert('아이디 또는 비밀번호가 다릅니다.')
        })
    },
    goPhoneCertificatePage() {
      this.$router.push('/phoneCertificate')
    },
    closePopup() {
      certificateForEmail(this.certificateNumber).then(res => {
        console.log(res.body)
        if (res.body === 'OK') {
          Message.err('인증이 완료되었습니다.')
          this.modal = false
          this.showCheckEmail = false
          this.disableSendEmail = false
          resetLoginCount()
          this.process()
        } else if (res.body === 'Check') {
          this.modal = false
          this.showCheckEmail = false
          this.disableSendEmail = false
          Message.err('인증번호 미발송 상태입니다. 발송 후 재시도 해주십시오.')
        } else {
          Message.err('인증정보가 올바르지 않습니다. 다시 확인해주십시오.')
        }
      })
    },
    sendEmail() {
      this.showCheckEmail = true
      this.disableSendEmail = true
      checkForEmail(this.email).then(response => {
        console.log('이메일 발송 성공')
      })
    },
    process() {
      this.$store.dispatch('GetUserMenus', store.state.user.userId)

      if (this.is_saved) {
        Cookies.set('saveID', this.userId, { expires: 365 })
      } else {
        Cookies.remove('saveID')
      }
      if (this.isAutoLogin) {
        Cookies.set(
          'autoLogin',
          this.userId + '[####]' + btoa(this.userPassword),
          { expires: 365 }
        )
      } else {
        Cookies.remove('autoLogin')
      }
      let sido = this.$route.query.sido ? this.$route.query.sido : ''
      let sigu = this.$route.query.sigu ? this.$route.query.sigu : ''
      let grpCd = localStore.get('grp_auth') ? localStore.get('grp_auth') : ''
      if (grpCd === 'usergroup005') {
        getMonitoringPersonal(this.userId, sido, sigu).then(res => {
          if (res.length <= 1 && isMobile) {
            if (res[0].SITE_ID.startsWith('E')) {
              this.$router.replace('/mobile/ess/siteWork?site_id=' + res[0].SITE_ID)
            } else {
              this.$router.replace('/mobile/siteWork?site_id=' + res[0].SITE_ID)
            }
          } else {
            this.$router.replace('/monitoring').catch(res => {})
          }
        })
      } else {
        this.$router.replace('/monitoring').catch(res => {})
      }
    },
    toggleContext(index, type) {
      let contents
      if (type === 'notice') {
        contents = this.noticeList[index]
      } else {
        contents = this.resourceList[index]
      }
      this.context.type = type
      this.context.content = contents.content
      this.context.title = contents.title
      this.context.date = contents.insdate

      this.showContext = !this.showContext
    }
  }
}
</script>

<style lang="less" scoped>
//@import '../../assets/pc_login.less';
// @import '../../assets/new_login.less';
// .cursor {
//   cursor: pointer;
// }
.vapp-root {
  background-image: url('~@/assets/image/bg_web.png');
  background-repeat: no-repeat;
  background-size: cover;
  position: fixed;
  height: 100vh;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 6;
}
.date {
  font-size: 12px;
}
.board_title {
  font-size: 14px;
  margin-left: 8px;
}
.pd0 {
  padding: 0;
}
.pd20 {
  padding: 20px;
}
.mg0 {
  margin: 0;
}
.left_title {
  font-weight: bold;
  font-size: 4rem;
  color: white;
}
.layout {
  width: 80%;
  margin: 0 auto;
}
.btmLine {
  border-bottom: 1px solid #afafaf;
  padding-bottom: 6px;
}
.transpar {
  background-color: #ffffff00 !important;
}
.font-size-btn {
  font-size: 11px;
  cursor: pointer;
  text-decoration: underline;
  color: gray;
}
.font-size-12 {
  font-size: 12px;
}
.font-size-16 {
  font-size: 16px;
}
.font-size-24 {
  font-size: 24px;
}

.font-size-36 {
  font-size: 36px;
}
.callNum {
  font-size: 30px;
  font-weight: bold;
  margin-left: 8px;
}
.mb-40 {
  margin-bottom: 40px;
}
.mt-80 {
  margin-top: 80px;
}
.pd_title {
  padding-top: 16px;
  padding-bottom: 36px;
  padding-left: 0;
}
.pd4-0 {
  padding: 4px 0;
}
.cursor {
  cursor: pointer;
}
.pdLR0 {
  padding-left: 0;
  padding-right: 0;
  justify-content: center;
  display: flex;
  align-items: center;
  color: #a3a8ae;
}
.bbbbbcolor {
  color: #bbbbbb;
}
.requestAsColor {
  color: #0784f2;
}
.numberColor {
  color: #a3a8ae;
}
.context-list-title {
  width: 135px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
